/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/
import React from 'react';
import { useParams, Outlet } from "react-router-dom";
// BASE components
import NavLinkAdapter from '../../../../@BASE/core/NavLinkAdapter';
import BASESvgIcon from '../../../../@BASE/core/BASESvgIcon';
// Material UI
import IconButton from '@mui/material/IconButton';

function InstanceSidebar(props) {
  const { resource, instance } = props;
  // route params
  const routeParams = useParams();

	return (
  <div className="flex flex-col flex-auto max-w-full w-md">
    <IconButton
      className="absolute top-0 right-0 my-16 mx-32 z-10"
      sx={{ color: "black" }}
      component={NavLinkAdapter}
      to={`/${resource}/${routeParams.id}`}
      size="large"
    >
      <BASESvgIcon>heroicons-outline:x</BASESvgIcon>
    </IconButton>

    <Outlet context={{resource, instance}} />
  </div>
	);
}

export default InstanceSidebar;